export const cityOptions = [
  { value: "Lisbon", label: "Lisbon" },
  { value: "Porto", label: "Porto" },
  { value: "Funchal", label: "Funchal" },
  { value: "Coimbra", label: "Coimbra" },
  { value: "Braga", label: "Braga" },
  { value: "Aveiro", label: "Aveiro" },
  { value: "Viseu", label: "Viseu" },
  { value: "Leiria", label: "Leiria" },
  { value: "Evora", label: "Evora" },
  { value: "Setubal", label: "Setubal" },
  { value: "Viana do Castelo", label: "Viana do Castelo" },
  { value: "Guimaraes", label: "Guimaraes" },
  { value: "Santarem", label: "Santarem" },
  { value: "Castelo Branco", label: "Castelo Branco" },
  { value: "Portalegre", label: "Portalegre" },
  { value: "Beja", label: "Beja" },
  { value: "Braganca", label: "Braganca" },
  { value: "Vila Real", label: "Vila Real" },
  { value: "Ponta Delgada", label: "Ponta Delgada" },
  { value: "Angra do Heroismo", label: "Angra do Heroismo" },
  { value: "Horta", label: "Horta" },
  { value: "Machico", label: "Machico" },
  { value: "Cascais", label: "Cascais" },
  { value: "Sintra", label: "Sintra" },
  { value: "Almada", label: "Almada" },
  { value: "Amadora", label: "Amadora" },
  { value: "Oeiras", label: "Oeiras" },
  { value: "Faro", label: "Faro" },
  { value: "Portimão", label: "Portimao" },
  { value: "Lagos", label: "Lagos" },
  { value: "Vila Nova de Gaia", label: "Vila Nova de Gaia" },
  { value: "Matosinhos", label: "Matosinhos" },
  { value: "Cova da Piedade", label: "Cova da Piedade" },
  { value: "Seixal", label: "Seixal" },
  { value: "Barreiro", label: "Barreiro" },
  { value: "Póvoa de Varzim", label: "Povoa de Varzim" },
  { value: "Leça da Palmeira", label: "Leca da Palmeira" },
  { value: "Viseu", label: "Viseu" },
  { value: "Santarém", label: "Santarem" },
  { value: "Tomar", label: "Tomar" },
  { value: "Évora", label: "Evora" },
  { value: "Elvas", label: "Elvas" },
  { value: "Beja", label: "Beja" },
  { value: "Serpa", label: "Serpa" },
  { value: "Vila Real de Santo António", label: "Vila Real de Santo Antonio" },
  { value: "Bragança", label: "Braganca" },
  { value: "Mirandela", label: "Mirandela" },
  { value: "Chaves", label: "Chaves" },
  { value: "Guarda", label: "Guarda" },
  { value: "Covilhã", label: "Covilha" },
  { value: "Fundão", label: "Fundao" },
  { value: "Castelo Branco", label: "Castelo Branco" },
  { value: "Portalegre", label: "Portalegre" },
  { value: "Elvas", label: "Elvas" },
  { value: "Vila Viçosa", label: "Vila Vicosa" },
  { value: "Loulé", label: "Loule" },
  { value: "Silves", label: "Silves" },
  { value: "Albufeira", label: "Albufeira" },
  { value: "Tavira", label: "Tavira" },
  { value: "Vila Real", label: "Vila Real" },
  { value: "Peso da Régua", label: "Peso da Regua" },
  { value: "São João da Madeira", label: "Sao Joao da Madeira" },
  { value: "Santa Maria da Feira", label: "Santa Maria da Feira" },
  { value: "Vila Nova de Famalicão", label: "Vila Nova de Famalicao" },
  { value: "Póvoa de Santa Iria", label: "Povoa de Santa Iria" },
];
